/** Legacy spoke adapter. All/unknown/Management never silently become DEV. */
import React, { createContext, useContext } from 'react';
import { useScope } from './ScopeContext';
import { currentObservationKey } from '../scope/runtime';
export type Environment = 'dev' | 'test' | 'uat' | 'prod';
export const ENVIRONMENTS: Environment[] = ['dev', 'test', 'uat', 'prod'];
/** Legacy display inventory only. Runtime requests use the registered selection. */
export const PROVISIONED_ENVIRONMENTS = ['dev', 'test'] as Environment[] & { includes(value: unknown): boolean };
export function readInitialEnvironment(): Environment | null { return null; }
interface EnvironmentContextValue {
  environment: Environment | null; legacyKey: string | null; label: string;
  setEnvironment: (env: string) => void; environments: Environment[];
  provisioned: readonly Environment[]; hasExplicitEnvironment: boolean; clearEnvironment: () => void;
}
const EnvironmentContext = createContext<EnvironmentContextValue | undefined>(undefined);
export const EnvironmentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const scope = useScope();
  const environment = ENVIRONMENTS.includes(scope.legacyKey as Environment) ? scope.legacyKey as Environment : null;
  const provisioned = scope.registry.kind === 'available' ? scope.registry.rows.filter(row => row.lifecycle === 'ready' && ENVIRONMENTS.includes(row.legacyKey as Environment)).map(row => row.legacyKey as Environment) : [];
  return <EnvironmentContext.Provider value={{ environment, legacyKey: scope.legacyKey, label: scope.label,
    setEnvironment: scope.setEnvironmentId, environments: ENVIRONMENTS, provisioned,
    hasExplicitEnvironment: scope.resolved.kind === 'environment', clearEnvironment: () => scope.setEnvironmentId(null) }}>{children}</EnvironmentContext.Provider>;
};
export function useEnvironment(): EnvironmentContextValue {
  const value = useContext(EnvironmentContext); if (!value) throw new Error('EnvironmentProvider required'); return value;
}
export function envKey(environment: string | null, ...parts: unknown[]): unknown[] { return currentObservationKey('env', environment, ...parts); }

export function requireSpokeEnvironment(value: Environment | null): Environment { if (!value) throw new Error('A registered spoke environment is required'); return value; }
